import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/reducers';
import { sessionIsUsuarioExterno } from 'src/app/session/store/session.selectors';

@Component({
	selector: 'info',
	templateUrl: './info.component.html',
	styleUrls: ['./info.component.scss']
})
export class InfoComponent {

	isUsuarioExterno$: Observable<boolean>;

	constructor( private store: Store<AppState> ) {
		this.isUsuarioExterno$ = this.store.select( sessionIsUsuarioExterno );
	}

}
